import { Box, Checkbox, MenuItem, Text } from '@chakra-ui/react';

export function VirtualFilterItem({
  virtualRow,
  item,
  measureElement,
  selectedItems,
  onCheckboxChange,
}: {
  virtualRow: {
    index: number;
  };
  item:
    | {
        id: string;
        value: string;
        label: string;
        element?: React.ReactElement;
      }
    | undefined;
  measureElement: (element: HTMLElement | null) => void;
  selectedItems: string[];
  onCheckboxChange: (id: string) => void;
}) {
  if (!item) {
    return null;
  }

  return (
    <Box data-index={virtualRow.index} ref={measureElement}>
      <MenuItem onClick={() => onCheckboxChange(item.id)} display="flex" alignItems="center">
        <Checkbox
          isChecked={selectedItems.includes(item?.id)}
          onChange={() => onCheckboxChange(item.id)}
          mr={2}
        />

        {item.element ? (
          item.element
        ) : (
          <Text fontSize="sm" as={'span'}>
            {(item as { label: string })?.label}
          </Text>
        )}
      </MenuItem>
    </Box>
  );
}
